import { render } from "./AddVESEventCard.vue?vue&type=template&id=08918dc7&scoped=true&ts=true"
import script from "./AddVESEventCard.vue?vue&type=script&lang=ts"
export * from "./AddVESEventCard.vue?vue&type=script&lang=ts"

import "./AddVESEventCard.vue?vue&type=style&index=0&id=08918dc7&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08918dc7"]])

export default __exports__